import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/system';
import MediaTypography from 'components/MediaTypography';
import { LanguageTranslationKeys } from 'i18n/languages/en';

import bookingRestrictionImage from '@common/assets/images/appointments-visual-guide/booking-restriction-image.webp';
import laptopIcon from '@common/assets/images/appointments-visual-guide/laptop-icon.png';
import { useServiceRouter } from '@common/components/ServiceRouter';

import { StyledIcon } from '../../styled';
import { InfoItemWrapper, InfoSectionWrapper, StyledImage } from './styled';

export interface AdditionalInfoSectionType {
	note: LanguageTranslationKeys;
	bookingRestriction: LanguageTranslationKeys;
	sessionLinkInfo: LanguageTranslationKeys;
}

interface IProps {
	additionalInfoSection: AdditionalInfoSectionType;
}

function AdditionalInfoSection({ additionalInfoSection }: IProps) {
	const { t } = useTranslation();
	const { checkService } = useServiceRouter();
	const isLyceum = checkService('lyceum');

	return (
		<InfoSectionWrapper>
			<InfoItemWrapper>
				<MediaTypography color="#333" variant="body2" sx={{ whiteSpace: 'pre-line', width: '50%' }}>
					<b>{t(additionalInfoSection.note)}</b>
					{t(additionalInfoSection.bookingRestriction)}
				</MediaTypography>
				<StyledImage src={bookingRestrictionImage} sx={{}} />
			</InfoItemWrapper>
			<InfoItemWrapper>
				<MediaTypography
					color="#333"
					variant="body2"
					sx={{ whiteSpace: 'pre-line', textIndent: '40px', position: 'relative' }}
				>
					<StyledIcon
						src={laptopIcon}
						alt="laptop-icon"
						sx={{ position: 'absolute', left: 0, top: '-6px' }}
					/>
					{isLyceum ? (
						<Box display="flex" flexDirection="column" gap={1}>
							{t('appointment.lyceumVisualGuide.sessionLinkInfo')}
							<b style={{ textIndent: 0 }}>
								{t('appointment.lyceumVisualGuide.meetingSuccessMessage')}
							</b>
						</Box>
					) : (
						t(additionalInfoSection.sessionLinkInfo)
					)}
				</MediaTypography>
			</InfoItemWrapper>
		</InfoSectionWrapper>
	);
}

export default AdditionalInfoSection;
